<template>
    <div class="app-container">
      <div class="table__page">
        <el-row style="margin-top: 10px;margin-bottom: 20px">
          <el-col :span="6">
            <label style="font-size: 18px">积分规则</label>
          </el-col>
        </el-row>
        <hr style="color: #8b8b8b">
        <el-row style="margin-top: 25px">
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
        </el-row>
        <el-row style="margin-top: 25px; text-align: center;">
            <el-button type="default" size="small" v-if="isEditFlag" @click="toCancel">取消</el-button>
            <wt-auth :hasAnyPremission="'MODULE_INTEGRALRULES:EDIT'" class="search-form-btn">
              <el-button type="primary" size="small" v-if="!isEditFlag" @click="toEdit">编辑</el-button>
            </wt-auth>
            <el-button type="primary" size="small" v-if="isEditFlag" @click="saveBtn">保存</el-button>
        </el-row>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Aboutus',
  data() {
    return {
      isEditFlag: false,
      detailForm: {
        title: '',
        className: 'wt-section-long-content',
        elements: [
          { name: '积分规则内容', key: 'content', type: 'editor', disabled: true, required: false }]
      },
      detailFormData: {}
    }
  },
  methods: {
    toEdit() {
      for (const item of this.detailForm.elements) {
        item.disabled = false
        item.required = true
      }
      this.isEditFlag = true
    },
    toCancel() {
      for (const item of this.detailForm.elements) {
        item.disabled = true
        item.required = false
      }
      this.isEditFlag = false
      this.systemDetail()
    },
    saveBtn() {
      request.post('/modules/system/systemUpdate', this.detailFormData).then(res => {
        if (!res) return false
        this.toCancel()
      })
    },
    systemDetail() {
      request.post('/modules/system/systemDetail', { type: 3 }).then(res => {
        this.detailFormData = res.data ? res.data : {
          type: 3
        }
      })
    }
  },
  mounted() {
    this.systemDetail()
  }
}
</script>
